export class TicketNav {
  to = { name: '' }

  title = ''

  key = ''

  isEditable = true

  isOptions = false

  requiredFields = null

  constructor (to = { name: '' }, title, key, isEditable, isOptions, requiredFields) {
    this.to = to
    this.title = title
    this.key = key
    this.isEditable = isEditable
    this.isOptions = isOptions
    this.requiredFields = requiredFields
  }
}

export default [
  new TicketNav({ name: 'main' }, 'Общая информация', '', true, false, [
    'title',
    'slug',
    'price',
    'ageRestriction',
    'bookingType',
    'attributes',
    'description'
  ]),
  new TicketNav({ name: 'schedules' }, 'Расписания', '', true, false, ['eventSchedules']),
  new TicketNav({ name: 'places' }, 'Рассадка и места', '', false, true, false),
  new TicketNav({ name: 'tickets' }, 'Билеты', '', false, true, false)
]
